<template>
  <div>
    <CalendarGuideStep
      v-for="(step, i, n) in steps"
      :key="i"
      :header="n + 1 | formattedNumber"
      :label="step.title"
      :link="step.link"
      :image="step.image"
    />
  </div>
</template>

<script>
import CalendarGuideStep from '@/components/calendar/calendarGuides/CalendarGuideStep'
export default {
  name: 'CalendarGuide',
  components: {
    CalendarGuideStep
  },
  props: {
    steps: {
      type: Array,
      require: true
    }
  },
  filters: {
    formattedNumber(value) {
      return value < 10 ? `0${value}` : value
    }
  }
}
</script>

<style>

</style>